import { Button } from "@progress/kendo-react-buttons";
import { Grid, GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import React,{ useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../Core/store.hooks";
import { getInterruptsSelector, removeSeries } from "./machineHealthSlice";

interface WidgetProps{
    id:string;
    header:string;
    legendSeries:any[];
    updateLegendSeries:any;
}

const AdvancedLegendGrid = (props:WidgetProps) => {
    const [legendSeries, updateLegendSeries] = useState([]);
    const dispatch = useAppDispatch()

    useEffect(()=>{
        
        updateLegendSeries(props.legendSeries)
    },[props.legendSeries])

    const CustomCell = (props: GridCellProps) => {
        const [color, setColor] = useState("black");

        useEffect(()=>{
            if(props.dataItem.color){
                setColor(props.dataItem.color)
            }
        },[])

        const toggleDisabled = () =>{
            
            if(props.dataItem.series.visible){
                props.dataItem.series.hide()
                setColor("#dadada")
            }else{
                props.dataItem.series.show()
                setColor(props.dataItem.color.hex)
            }
        }

        const hoverOn = () =>{
            if(props.dataItem.series.visible){
                legendSeries.forEach((obj)=>{
                    if(props.dataItem.seriesID !== obj.series.dataFields.valueY){
                        
                        obj.series.strokeOpacity = 0.1;
                        obj.bullet.fillOpacity = 0;
                        obj.bullet.strokeOpacity = 0;
                    }
                })
            }
        }

        const hoverOff = () =>{
            legendSeries.forEach((obj)=>{
                obj.series.strokeOpacity = 1
                obj.bullet.fillOpacity = 1
                obj.bullet.strokeOpacity = 1
            })
        }

        return(
          <td onClick={toggleDisabled} onMouseOver={hoverOn} onMouseLeave={hoverOff} style={{"color":color, "cursor":"pointer", "userSelect":"none"}}> 
            {props.dataItem.seriesID}
          </td>
        )
      }

    const handleGridButton = (seriesID:string) =>{
        dispatch(removeSeries(seriesID));
    }

    const CommandCell = (props:GridCellProps) => {
        return(
          <td> 
                <Button className="pp-small-kendo-button" onClick={() => handleGridButton(props.dataItem.seriesID)} title="Remove Series">X</Button>
          </td>
        )
      }

    return (<div className="pp-slim-grid">
        <Grid data={legendSeries} style={{ fontSize: "13px", height: " 100%" }} resizable={true} >
        <GridColumn cell={CustomCell}  width="100px" />
        <GridColumn field="interruptCount" title="Interrupt Count" width="57px"/>
            <GridColumn field="runningDuration" title="Running Duration" width="57px" />
            <GridColumn field="interruptsPerRunningHour" title="Interrupts / Running Hr" width="72px" />
        <GridColumn cell={CommandCell}   width="80px"/>
        </Grid>
    </div>
    )
}

export default AdvancedLegendGrid;